import { useParams, useNavigate } from "react-router-dom";
import { UserPlus, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { useAuth, login } from "@/hooks/useAuth";
import { api } from "@/lib/api";

const MakeOwn = ({ className, testId }) => {
  const { token } = useParams();
  return (
    <button onClick={() => login(token)} data-testid={testId}
      className={`flex items-center gap-2 rounded-full bg-emerald-400 text-[#04120c] font-semibold hover:bg-emerald-300 hover:-translate-y-0.5 transition-[transform,background-color] duration-200 ${className}`}>
      <Sparkles size={15} /> Make my own bucket list
    </button>
  );
};

export const MakeOwnFloating = () => {
  const { user } = useAuth();
  if (user !== null) return null;
  return (
    <div className="fixed z-40 bottom-5 inset-x-0 flex justify-center sm:justify-end sm:right-8 sm:left-auto px-4 pointer-events-none animate-rise">
      <MakeOwn testId="make-own-floating-button" className="pointer-events-auto px-6 py-3.5 text-sm shadow-[0_10px_40px_-8px_rgba(52,211,153,0.6)]" />
    </div>
  );
};

export const FollowButton = () => {
  const { token } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) return <MakeOwn testId="make-your-own-link" className="hidden sm:flex px-4 py-1.5 text-sm" />;

  const follow = async () => {
    try {
      const f = await api.follow(token);
      toast.success(`You're now following ${f.name}`);
      navigate("/#friends");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not follow");
    }
  };
  return (
    <button onClick={follow} className="flex items-center gap-1.5 text-sm px-3 py-1.5 rounded-full bg-sky-400 text-[#06121c] hover:bg-sky-300 transition-colors" data-testid="follow-owner-button">
      <UserPlus size={14} /> Follow
    </button>
  );
};
